<template lang="">
  <div class="mains">
    <div class="container">
      <div class="header_title">退货列表</div>
      <div class="top">
        <Button class="newBotton" @click="inAddVal()">
          <!-- <Icon type="ios-add" size="50px" /> -->
          <span class="newBottonText">新增</span>
        </Button>
        <div class="select">
          <Input v-model="selectVal" search placeholder="输入企业代码" />
        </div>
      </div>
      <div class="main mains">
        <el-empty description="没有数据哦！" v-if="pageData.length==0"/>
        <Table border :columns="columns" :data="pageData" style="width: 100%"  v-if="pageData.length!==0">
          <!-- <Table border :columns="columns" :data="datas" style="width:100%;"> -->
          <template #name="{ row }">
            <strong>{{ row.name }}</strong>
          </template>
          <template #action="{ row, index }">
            <Button style="margin-right: 5px" @click="show(index)">修改</Button>
            <Button type="error" @click="remove(index)">删除</Button>
          </template>
        </Table>
        <!-- 分页 -->
        <Page
          class="page"
          :modelValue="pages"
          :total="allPage"
          simple
          @on-change="page"
        />
      </div>

      <Drawer
        title="修改企业资料"
        :closable="false"
        v-model="value"
        width="600"
      >
        <updateResult
          :ResultDate="pageData[Indexs]"
          @resultDates="resultDatePro"
        ></updateResult>
      </Drawer>
      <Drawer title="新建回复" :closable="false" v-model="addVal" width="600">
        <NewResult @addResultList="addResult"></NewResult>
      </Drawer>
    </div>
  </div>
</template>
<script>
import NewResult from "@/views/ResultList/newResult";
import updateResult from "@/views/ResultList/updateResult";
import { GetSalesReturnList, DelResultList } from "@/api/index";
export default {
  data() {
    return {
      selectVal: "",
      value: false,
      addVal: false,
      // 1 id            id
      // 2 企业代码      clientcode
      // 2 首次查询信息  AselRes
      // 3 重复查询信息  BselRes
      // 4 多次查询信息  CselRes
      // 5 最后修改时间  time
      columns: [
        {
          title: "id",
          key: "",
          width: 65,
          render: (h, params) => {
            return h("span", params.index + 1);
          },
        },
        {
          title: "标签序号",
          key: "code",
          width: 100,
        },
        {
          title: "产品名称",
          key: "product_name",
          minWidth: 100,
        },
        {
          title: "经销商名称",
          key: "user_name",
          minWidth: 100,
        },
        {
          title: "经销商手机号",
          key: "user_phone",
          minWidth: 120,
        },
        {
          title: "发货仓库",
          key: "user_name",
          minWidth: 100,
        },
        {
          title: "退货时间",
          key: "sales_time",
          width: 200,
        },
        {
          title: " ",
          slot: "action",
          width: 170,
          align: "center",
          fixed: "right",
        },
      ],
      // 源数据
      datas: [],
      // 搜索后的数据
      inData: [],
      // 分页后的数据
      pageData: [],
      inDatas: {
        inCode: "",
        inName: "",
        inWrite: "",
        inDate: "",
      },
      pages: 1,
      allPage: 1,
      Indexs: 1,
    };
  },
  components: {
    NewResult,
    updateResult,
  },
  beforeCreate() { },
  mounted() {
    // 获取正品回复导语
    GetSalesReturnList({
      code: 2,
    }).then((res) => {
      if (res.code == 402) {
        this.$Notice.error({ title: "没有查看权限！" });
      }
      // console.log(res);
      this.datas = res;
      this.pageData = res.filter((p, key) => {
        if (key < this.pages * 10 && key >= this.pages * 10 - 10) {
          return p;
        }
      });
      this.allPage = this.datas.length;
    });
  },
  updated() { },
  watch: {
    // 搜索过滤
    selectVal(newVal, oldVal) {
      var data = this.datas.filter((p) => {
        if (p.clientcode.indexOf(newVal) !== -1) {
          return p;
        }
      });
      this.pages = 1;
      this.allPage = data.length;
      let arr = data.filter((p, key) => {
        if (key < this.pages * 10 && key >= this.pages * 10 - 10) {
          return p;
        }
      });
      this.pageData = arr;
    },
  },
  methods: {
    inAddVal(index) {
      this.addVal = true;
    },
    show(index) {
      this.value = true;
      this.Indexs = index;
    },
    // 删除按钮
    remove(index) {
      const code = this.pageData[index].clientcode;
      const id = this.pageData[index].id;
      this.$confirm("此操作将永久删除该" + code + "字段, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 提交删除请求
          DelResultList({
            id,
          }).then((res) => {
            if (res.code == 402) {
              this.$Notice.error({ title: "没有权限！" });
            }
            if (res == 1) {
              this.pageData.splice(index, 1)
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败！",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 分页过滤
    page(i) {
      this.pages = i;
      var data = this.datas.filter((p) => {
        return p.name.indexOf(this.selectVal) !== -1;
      });
      // this.pages = 1
      let arr = data.filter((p, key) => {
        if (key < this.pages * 10 && key >= this.pages * 10 - 10) {
          return p;
        }
      });
      this.pageData = arr;
    },
    // 接收来自子组件的回值---添加信息
    async addClientList(value) {
      this.datas.push(value);
    },

    // 修改成功后的操作
    resultDatePro(res) {
      this.pageData[this.Indexs].AselRes = res.Ares;
      this.pageData[this.Indexs].BselRes = res.Bres;
      this.pageData[this.Indexs].CselRes = res.Cres;
      this.value = false;
      this.$Notice.success({ title: "修改成功" });
    },

    // 添加成功后的操作
    addResult(res) {
      this.datas.push({
        clientcode: res.clientcode,
        AselRes: res.Ares,
        BselRes: res.Ares,
        CselRes: res.Cres,
      });
      this.addVal = false;
      this.$Notice.success({ title: "添加成功-刷新查看" });
    },
  },
};
</script>
<style scoped >
.top {
  width: 100%;
  background: white;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.select {
  margin-left: 10px;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
